import { cloneDeep } from "lodash";

import { createTag, getTags, deleteTag, editTag, getTagBotConfigs } from "../utils/tag";
import { clientTagAction } from "./conversationsDuck";
import CONSTANTS from "../const/constants";

const TAGS_STATE = {
  fetching: false,
  fetched: false,
  data: [],
  selected: {},
  disabledBotTags: [],
};

const GET_TAGS_SUCESS = "GET_TAGS_SUCESS";
const GET_TAGS = "GET_TAGS";
const SET_SELECTED_TAG = "SET_SELECTED_TAG";
const UPDATE_CLIENT_TAG = "UPDATE_CLIENT_TAG";
const UPDATE_CLIENT_TAG_END = "UPDATE_CLIENT_TAG_END";
const GET_TAG_BOT_CONFIGS_SUCCESS = "GET_TAG_BOT_CONFIGS_SUCCESS";

export default function tagsReducer(state = TAGS_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_TAGS:
      return { ...state, fetching: true };
    case GET_TAGS_SUCESS:
      return { ...state, fetching: false, data: payload };
    case SET_SELECTED_TAG:
      return { ...state, selected: payload };
    case UPDATE_CLIENT_TAG:
      return { ...state, fetching: true };
    case UPDATE_CLIENT_TAG_END:
      return { ...state, fetching: false };
    case GET_TAG_BOT_CONFIGS_SUCCESS:
      return { ...state, disabledBotTags: payload };
    default:
      return state;
  }
}

export const saveTagAction = (name, color) => async (_, getState) => {
  try {
    const companyId = getState().user.data.company.id;
    const key = `${companyId}-${name}`;
    
    // Para la compañía específica, obtener spaceId del espacio seleccionado
    let spaceId = null;
    if (companyId === CONSTANTS.SPACE_FILTERED_COMPANY_ID) {
      spaceId = getState().spaces?.selected?.id || null;
    }
    
    const response = await createTag(name, color, companyId, key, spaceId);
    return response?.id;
  } catch (error) {
    throw error;
  }
};

export const getTagsByCompanyAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_TAGS });
    const companyId = getState().user.data.company.id;
    
    // Para la compañía específica, obtener spaceId del espacio seleccionado
    let spaceId = null;
    if (companyId === CONSTANTS.SPACE_FILTERED_COMPANY_ID) {
      spaceId = getState().spaces?.selected?.id || null;
    }
    
    const { tags } = await getTags(companyId, spaceId);
    dispatch({ type: GET_TAGS_SUCESS, payload: cloneDeep(tags) });
    return cloneDeep(tags);
  } catch (error) {
    throw error;
  }
};

export const getTagBotConfigsAction = () => async (dispatch) => {
  try {
    const response = await getTagBotConfigs();
    dispatch({ type: GET_TAG_BOT_CONFIGS_SUCCESS, payload: response || [] });
    return response;
  } catch (error) {
    console.error("Error fetching tag bot configs:", error);
    return [];
  }
};

export const getAllTagsByCompany = () => async (dispatch, getState) => {
  try {
    const companyId = getState().user.data.company.id;
    
    // Para la compañía específica, obtener spaceId del espacio seleccionado
    let spaceId = null;
    if (companyId === CONSTANTS.SPACE_FILTERED_COMPANY_ID) {
      spaceId = getState().spaces?.selected?.id || null;
    }
    
    const { tags } = await getTags(companyId, spaceId);    
    return tags;
  } catch (error) {
    throw error;
  }
};

export const eraseTagAction = (id) => async (dispatch, getState) => {
  try {
    const response = await deleteTag(id);
    // Las etiquetas viven en `state.tags.data`. Leer de `state.configurations` (que es
    // dataSheetConfigurationDuck y nunca tuvo clave `tags`) devolvía undefined, y lodash lo
    // aceptaba sin protestar: el dispatch dejaba la lista ENTERA en undefined y reventaba a
    // los consumidores del chat y de campañas. Filtro inmutable: no mutar el estado de Redux.
    const currentTags = getState().tags.data || [];
    const newTags = currentTags.filter((tag) => tag.id !== response.id);
    dispatch({ type: GET_TAGS_SUCESS, payload: newTags });
    return response;
  } catch (error) {
    throw error;
  }
};

export const setSelectedTagAction = (tag) => async (dispatch) => {
  try {
    dispatch({ type: SET_SELECTED_TAG, payload: tag });
  } catch (error) {
    throw error;
  }
};

export const editTagAction =
  (id, name, color) => async (dispatch, getState) => {
    try {
      const companyId = getState().user.data.company.id;
      const key = `${companyId}-${name}`;
      await editTag(id, name, color, key);
      
      // Para la compañía específica, obtener spaceId del espacio seleccionado
      let spaceId = null;
      if (companyId === CONSTANTS.SPACE_FILTERED_COMPANY_ID) {
        spaceId = getState().spaces?.selected?.id || null;
      }
      
      const { tags } = await getTags(companyId, spaceId);
      dispatch({ type: GET_TAGS_SUCESS, payload: tags });
    } catch (error) {
      throw error;
    }
  };

export const AddTagToClient = (clientId, tag, add) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_CLIENT_TAG });
    await dispatch(clientTagAction(clientId, tag, add));
    dispatch({ type: UPDATE_CLIENT_TAG_END });
  } catch (error) {
    dispatch({ type: UPDATE_CLIENT_TAG_END });
    throw error;
  }
};
